import { OpportunitiesConfigOptions } from 'common/models/Configuration/Opportunities';
import { ChangeTracker } from 'common/models/hooks/ChangeTracker';

export const DefaultOptions: OpportunitiesConfigOptions = {
  OpportunityDefaultSummary: '',
};

export const NoChangesTracker: ChangeTracker<OpportunitiesConfigOptions> = {
  OpportunityDefaultSummary: false,
};
